<div *ngIf="loadingUnitData" class="alert alert-info"><strong><i class="la la-spinner la-spin"></i> Nalagam
  podatke</strong></div>
<ng-container *ngIf="unit && !loadingUnitData">
  <h3>{{unit.title.raw}}</h3>

  <form [formGroup]="form" novalidate (submit)="update(form)">
    <div class="tabs tabs-alt tabs-tb clearfix ui-tabs ui-corner-all ui-widget ui-widget-content">
      <ul
        class="nav nav-tabs tab-nav clearfix ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
        id="myTab" role="tablist">
        <li class="nav-item ui-tabs-tab ui-corner-top ui-state-default ui-tab">
          <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
             aria-selected="true">Osnovne informacije</a>
        </li>
        <li class="nav-item ui-tabs-tab ui-corner-top ui-state-default ui-tab">
          <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
             aria-selected="false">Urniki</a>
        </li>
        <li class="nav-item ui-tabs-tab ui-corner-top ui-state-default ui-tab">
          <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab"
             aria-controls="contact"
             aria-selected="false">Storitve</a>
        </li>
      </ul>
    </div>
    <div class="tab-content pt-3" id="myTabContent">
      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="form-group">
          <label for="title">Naziv enote</label>
          <input type="text" class="form-control" id="title" formControlName="title">
          <small class="form-text text-danger" *ngIf="form.controls.title.invalid">
            Naziv enote je obvezen
          </small>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="address">Naslov</label>
            <input type="text" class="form-control" id="address" formControlName="address">
          </div>
          <div class="form-group col-md-2">
            <label for="postNumber">Pošta</label>
            <input
              formControlName="postNumber"
              [typeahead]="postNumbersFilter"
              [typeaheadItemTemplate]="customItemTemplate"
              id="postNumber"
              (typeaheadOnSelect)="onPostSelect($event)"
              autocomplete="off"
              class="form-control">
          </div>

          <div class="form-group col-md-4">
            <label for="poste">Pošta</label>
            <input
              formControlName="poste"
              [typeahead]="posteFilter"
              [typeaheadItemTemplate]="customItemTemplate"
              id="poste"
              (typeaheadOnSelect)="onPostSelect($event)"
              autocomplete="off"
              class="form-control">
          </div>

          <ng-template #customItemTemplate let-model="item" let-index="index">
            {{model.number}} {{model.name}}
          </ng-template>
        </div>

        <div class="form-group">
          <label for="website">Spletna stran</label>
          <input type="text" class="form-control" id="website" formControlName="website">
          <small class="form-text text-danger" *ngIf="form.controls.website.invalid">
            Spletna stran ni v pravilni obliki (https://www.zdravstvena-ustanova.si/ambulanta-1/)
          </small>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="email">E-naslov</label>
            <input type="text" class="form-control" id="email" formControlName="email">
            <small class="form-text text-danger" *ngIf="form.controls.email.invalid">
              Elektronski naslov ni pravilen.
            </small>
          </div>

          <div class="form-group col-md-6">
            <label for="phoneNumber">Telefon</label>
            <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber">
          </div>
        </div>
        <ng-container *ngIf="contractor && contractor.acf.contractor_premium">
          <div class="form-group mt-3">
            <label for="premium">Premium vsebine</label>
            <select id="premium" type="text" class="form-control" formControlName="premium">
              <option [value]="false">Brez</option>
              <option [value]="premium.id" *ngFor="let premium of premiums">{{premium.title.raw}}</option>
            </select>
          </div>
          <div class="d-flex justify-content-end">
            <button class="button button-3d button-light button-small align-self-end" type="button"
                    [routerLink]="['/ustanova', contractorId, 'premium', 'nov']">
              <i class="la la-plus"></i> Kreiraj novo premium vsebino
            </button>
          </div>
        </ng-container>
      </div>
      <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
        <div class="d-flex flex-column">
          <table class="table table-sm table-borderless">
            <thead>
            <tr>
              <th width="200" class="uppercase">Urnik</th>
              <th width="110" class="uppercase">Naziv urnika</th>
              <th class="uppercase">Telefon</th>
              <th class="uppercase">E-naslov</th>
              <th class="uppercase">Tip</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr formArrayName="timetables" *ngFor="let item of form.get('timetables').controls; let i = index;">
              <ng-container [formGroupName]="i">
                <td>
                  <select type="text" class="form-control form-control-sm" formControlName="relation">
                    <option [value]="timetable.id" *ngFor="let timetable of timetables">{{timetable.title.raw}}</option>
                  </select>
                </td>
                <td><input type="text" class="form-control form-control-sm" formControlName="name"></td>
                <td><input type="text" class="form-control form-control-sm" formControlName="phone"></td>
                <td>
                  <input type="text" class="form-control form-control-sm" formControlName="email">
                  <small class="form-text text-danger"
                         *ngIf="item.controls.email.invalid">
                    <div>Elektronski naslov ni pravilen.</div>

                  </small>
                </td>
                <td>
                  <select type="text" class="form-control form-control-sm" formControlName="type">
                    <option [value]="type.value" *ngFor="let type of timeTableTypes">{{type.label}}</option>
                  </select>
                </td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-danger" type="button" (click)="removeTimetable(i)"><i
                      class="la la-remove"></i>
                    </button>
                    <button class="btn btn-outline-info" type="button"
                            [routerLink]="['/ustanova', contractorId, 'urnik', item.value.relation]">
                      <i class="la la-edit"></i>
                    </button>
                  </div>
                </td>
              </ng-container>
            </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end">
            <button class="button button-3d button-light button-small align-self-end" type="button"
                    (click)="addTimetable()">
              <i class="la la-plus"></i> Poveži urnik
            </button>
            <button class="button button-3d button-light button-small align-self-end" type="button"
                    [routerLink]="['/ustanova', contractorId, 'urnik', 'nov']">
              <i class="la la-plus"></i> Kreiraj nov urnik
            </button>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
        <div>
          <div *ngIf="loadingServicesData" class="alert alert-info"><strong><i class="la la-spinner la-spin"></i>
            Nalagam podatke</strong></div>
          <div class="d-flex flex-column" *ngIf="!loadingServicesData">
            <div *ngIf="services.length > 0 && services[0].wp_2_last_update_contractor">
              Podatki nazadnje posodobljeni:
              <strong>{{services[0].wp_2_last_update_contractor | date : 'd.M.y H:mm:ss'}}</strong>
              <hr>
            </div>
            <table class="table table-sm table-borderless">
              <thead>
              <tr>
                <th width="200" class="uppercase">Storitev</th>
                <th class="uppercase" tooltip="Vaš naziv storitve" container="body">Naziv</th>
                <th class="uppercase text-center" tooltip="Koncesija (na napotnico)" container="body">K</th>
                <th class="uppercase" tooltip="Čakalna doba - redno" container="body">Redno</th>
                <th class="uppercase" tooltip="Čakalna doba - hitro" container="body">Hitro</th>
                <th class="uppercase" tooltip="Čakalna doba - zelo hitro" container="body">ZH</th>
                <th class="uppercase text-center" tooltip="Samoplačniško" container="body">S</th>
                <th class="uppercase text-nowrap" tooltip="Čakalna doba - samoplačniško" container="body">Dni</th>
                <th class="uppercase text-nowrap" tooltip="Cena - samoplačniško" container="body">Cena</th>
              </tr>
              </thead>
              <tbody>
              <tr formArrayName="services" *ngFor="let item of form.get('services').controls; let i = index;">
                <ng-container [formGroupName]="i">
                  <td>
                    <input type="hidden" formControlName="row_id">
                    <strong *ngIf="item.value.vzs_id">{{item.value.vzs_id}}: </strong>{{item.value.title}}
                  </td>
                  <td><input type="text" class="form-control form-control-sm" formControlName="custom"></td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="concession[{{i}}]"
                             formControlName="concession" (change)="checkboxChange($event, 'concession', i)">
                      <label class="custom-control-label" for="concession[{{i}}]"></label>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" formControlName="wp_3_contractor">
                    <small class="form-text text-danger" *ngIf="item.get('wp_3_contractor').invalid">
                      <div>Čakalna doba mora biti vnešena v dnevih</div>
                    </small>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" formControlName="wp_2_contractor">
                    <small class="form-text text-danger" *ngIf="item.get('wp_2_contractor').invalid">
                      <div>Čakalna doba mora biti vnešena v dnevih</div>
                    </small>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" formControlName="wp_7_contractor">
                    <small class="form-text text-danger" *ngIf="item.get('wp_7_contractor').invalid">
                      <div>Čakalna doba mora biti vnešena v dnevih</div>
                    </small>
                  </td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="selfFunding[{{i}}]"
                             formControlName="selfFunding" (change)="checkboxChange($event, 'sf', i)">
                      <label class="custom-control-label" for="selfFunding[{{i}}]"></label>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" formControlName="wp_sf_contractor">
                    <small class="form-text text-danger" *ngIf="item.get('wp_sf_contractor').invalid">
                      <div>Čakalna doba mora biti vnešena v dnevih</div>
                    </small>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" formControlName="wp_sf_price_contractor">
                    <small class="form-text text-danger" *ngIf="item.get('wp_sf_price_contractor').invalid">
                      <div>Cena mora biti v obliki <strong>1000.00</strong></div>
                    </small>
                  </td>
                </ng-container>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between">
      <div>
        <div class="style-msg successmsg" *ngIf="formSucces">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Bravo!</strong>
            Podatki so bili uspešno shranjeni.
          </div>
        </div>
        <div class="style-msg errormsg" *ngIf="formError">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Napaka!</strong>
            {{formError}}
          </div>
        </div>
      </div>
      <button type="submit" class="button button-3d button-primary button-disabled" [disabled]="formProcessing">
        <i class="la la-check" *ngIf="!formProcessing"></i>
        <i class="la la-spinner la-spin" *ngIf="formProcessing"></i>
        Shrani spremembe
      </button>
    </div>
  </form>

</ng-container>
